import styled from '@emotion/styled';

export const AppWrapperContainer = styled.div`
  position: relative;
  min-height: 100vh;
`;
